import { useFormikContext } from "formik";
import React from "react";

export const useContactPersonObserver = (currentFieldsets) => {
    const { values, setFieldValue } = useFormikContext();
    const contactPerson = values.kundenundeinsatzort_wichtigeperson_ansprechpartner;

    return React.useMemo(() => {
        if (contactPerson) {
            if (contactPerson !== "Neuer Ansprechpartner") {
                setFieldValue("kundenundeinsatzort_wichtigeperson_ansprechpartnerfreitext", "");
            }
        }
		return {
			fieldsets: currentFieldsets
		}

    }, [contactPerson, currentFieldsets]);
};

const ContactPersonObserver = ({currentFieldsets, setCurrentFieldsets}) => {
	const {fieldsets} = useContactPersonObserver(currentFieldsets)
	setCurrentFieldsets(fieldsets);
	return null;
};

export default ContactPersonObserver;
